const formatTags = require("../../dict/formatTags.js");
module.exports = function replaceBoldTags(text, openTag, closeTag){
    let openPattern = new RegExp(formatTags.bold.open, "gmi"),
    closePattern = new RegExp(formatTags.bold.close, "gmi");
    return text.replace(openPattern,openTag).replace(closePattern, closeTag);
}